import { routerRedux } from 'dva/router';
import * as CR from '../services/pageGroups';
import { helpers } from '../utils';

export const ACTION_PAGEGROUPS_LOADLIST = 'pageGroups/loadList';
export const ACTION_PAGEGROUPS_LOAD_ITEM = 'pageGroups/loadItem';
export const ACTION_PAGEGROUPS_CREATE = 'pageGroups/create';
export const ACTION_PAGEGROUPS_UPDATE = 'pageGroups/update';
export const ACTION_PAGEGROUPS_REMOVE = 'pageGroups/remove';

export default {
  namespace: 'pageGroups',
  state: null,

  reducers: {
    updateStore(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },

  effects: {
    * loadList({ payload }, { call }) {
      try {
        return yield call(CR.pageGroupsListRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * loadItem({ payload }, { call }) {
      try {
        return yield call(CR.pageGroupsItemRequest, payload);
      } catch (e) {
        helpers.processException(e);
      }
    },

    * create({ payload }, { put, call }) {
      try {
        const { data, projectId } = payload;
        const response = yield call(
          CR.pageGroupsCreateRequest,
          {
            projectId,
          },
          data,
        );

        yield put({
          type: 'app/addNotification',
          payload: {
            type: 'success',
            message: 'Common.Success',
            description: 'Component.LeadScoring.New.Success.Text',
          },
        });

        yield put(routerRedux.push(`/${projectId}/page-groups/`));
        return response;
      } catch (e) {
        helpers.processException(e);
      }
    },

    * update(
      {
        payload: { id, data, projectId },
      },
      { put, call },
    ) {
      try {
        yield call(CR.pageGroupsUpdateRequest, { projectId, id }, { ...data });
        yield put({
          type: 'app/addNotification',
          payload: {
            type: 'success',
            message: 'Common.Success',
            description: 'Component.LeadScoring.Edit.Success.Text',
          },
        });
        yield put(routerRedux.push(`/${projectId}/page-groups/`));
      } catch (e) {
        helpers.processException(e);
      }
    },

    * remove(
      {
        payload: { id },
      },
      { put, call, select },
    ) {
      try {
        const { currentProjectId } = yield select(store => store.app);

        const resp = yield call(CR.pageGroupsRemoveRequest, {
          projectId: currentProjectId,
          id,
        });

        yield put({
          type: 'app/addNotification',
          payload: {
            type: 'success',
            message: 'Common.Success',
            description: 'Component.LeadScoring.Remove.Success.Text',
          },
        });
        yield put(routerRedux.push(`/${currentProjectId}/page-groups/`));
        return resp;
      } catch (e) {
        helpers.processException(e);
        return e;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/pageGroups.js